import BaseService from './base.service';

export default class GalleryService extends BaseService {
    constructor(ctx) {
        super(ctx);
    }

    getListGalleryTags = query => {
        return this.get('/gallery-web', query);
    };

    getGalleryByBusiness = query => {
        return this.get('/gallery/by-business', query);
    };

    getGalleryByDepartment = query => {
        return this.get('/gallery/by-department', query);
    };
}
